module.exports = __webpack_public_path__ + "static/media/vip-hour-tile-free.4dd3af48.png";